<template>
  <div class="bot-editar p-6">
    <div class="d-flex justify-content-end">
      <EmbeddedSignup />
    </div>
    <b-card class="shadow rounded-pill-xl mb-4 p-4 position-relative">
      <!-- Loading dentro do card -->
      <div
        v-if="carregando"
        class="card-loading-overlay"
      >
        <div class="loading-content">
          <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem;"
          />
          <h5 class="mt-3 text-primary">
            Carregando informações do assistente...
          </h5>
        </div>
      </div>

      <h4 class="mb-3">
        Informações do Assistente
      </h4>
      <div class="d-flex flex-column flex-md-row align-items-start">
        <div class="avatar-wrapper position-relative flex-shrink-0">
          <input
            ref="avatarInput"
            type="file"
            accept="image/*"
            class="d-none"
            @change="onAvatarChange"
          >
          <img
            :src="form.avatar || 'https://cdn-icons-png.flaticon.com/512/4712/4712038.png'"
            alt="avatar-bot"
            class="bot-avatar-lg mb-3 mb-md-0 mr-md-4"
          >
          <!-- <b-button
            size="sm"
            variant="light"
            class="avatar-button rounded-pill"
            @click="trocarAvatar"
          >
            Trocar Avatar
          </b-button> -->
        </div>
        <div class="w-100">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group label="Nome do Assistente">
                <b-form-input
                  v-model="form.nome"
                  placeholder="Ex: Leo"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group label="Tipo de Assistente">
                <b-badge
                  variant="info"
                  class="text-uppercase"
                >
                  {{ form.tipo }}
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group label="Loja vinculada">
                <b-form-select
                  v-model="form.lojaId"
                  :options="opcoesLoja"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group label="Personalidade do Assistente">
                <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                  <b-badge
                    variant="primary"
                    class="mr-md-2 mb-2 mb-md-0 px-3 py-2 text-capitalize"
                  >
                    {{ nomePersonalidade }}
                  </b-badge>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="px-2 py-1"
                    @click="mostrarModalPersonalidade = true"
                  >
                    ✏️ Alterar Personalidade
                  </b-button>
                </div>
              </b-form-group>
            </b-col>

            <SelecionarPersonalidade
              v-model="form.personalidade"
              :show.sync="mostrarModalPersonalidade"
            />

          </b-row>
        </div>
      </div>

      <!-- CONFIGURAÇÕES AVANÇADAS - Largura Total -->
      <b-card
        no-body
        class="mb-3 mt-3"
      >
        <b-card-header
          class="p-2 d-flex justify-content-between align-items-center"
          style="cursor: pointer;"
          @click="mostrarAvancado = !mostrarAvancado"
        >
          <div class="d-flex align-items-center">
            <b-icon
              :icon="mostrarAvancado ? 'chevron-up' : 'chevron-down'"
              class="mr-2"
            />
            <h6 class="mb-0">
              Configurações Avançadas
            </h6>
          </div>
        </b-card-header>

        <b-collapse v-model="mostrarAvancado">
          <b-card-body>

            <!-- Mensagem de Transferência -->
            <b-form-group label="Mensagem de Transferência para Atendente">
              <b-form-textarea
                v-model="form.mensagemTransferencia"
                placeholder="Ex: Olá! Vou te transferir para um atendente humano agora 😊"
                rows="3"
                maxlength="250"
              />
            </b-form-group>

            <!-- Ativar/Desativar CSAT -->
            <b-form-group label="Ativar Pesquisa de Satisfação (CSAT)">
              <b-form-checkbox
                v-model="form.csatAtivo"
                :value="1"
                :unchecked-value="0"
                switch
              >
                {{ form.csatAtivo === 1 ? 'Ativo' : 'Desativado' }}
              </b-form-checkbox>
            </b-form-group>

            <!-- Tempo CSAT -->
            <b-form-group
              v-if="form.csatAtivo"
              label="Tempo para envio da pesquisa (minutos)"
            >
              <b-form-input
                v-model.number="form.csatTempo"
                type="number"
                :min="30"
                :max="660"
                placeholder="Ex: 120"
              />
              <small class="text-muted">Mínimo: 30 minutos / Máximo: 660 minutos (11 horas)</small>

              <b-alert
                v-if="form.csatTempo < 30 || form.csatTempo > 660"
                variant="warning"
                show
                class="mt-2"
              >
                O tempo deve ser entre 30 e 660 minutos.
              </b-alert>
            </b-form-group>

          </b-card-body>
        </b-collapse>
      </b-card>

      <div class="d-flex flex-column flex-md-row justify-content-end mt-3">
        <b-button
          variant="success"
          size="sm"
          class="px-3 mr-md-2 mb-2 mb-md-0 p-1"
          @click="salvarInfoBot"
        >
          Salvar Alterações
        </b-button>

        <b-button
          variant="outline-success"
          size="sm"
          class="px-3 p-1"
          @click="abrirChat"
        >
          Testar Assistente
        </b-button>
      </div>
    </b-card>

    <!-- MÉTRICAS DO BOT -->
    <b-card class="shadow rounded-pill-xl p-4 mb-4">
      <h5 class="mb-3">
        Métricas do Assistente
      </h5>
      <b-row>
        <b-col
          v-for="m in metricas"
          :key="m.label"
          md="3"
        >
          <b-card
            class="text-center mb-2"
            :style="{ backgroundColor: m.cor, borderRadius: '1rem' }"
          >
            <b-icon
              :icon="m.icone"
              font-scale="1.5"
              class="mb-1"
            />
            <h4 class="mb-0">
              {{ m.valor }}
            </h4>
            <small>{{ m.label }}</small>
          </b-card>
        </b-col>
      </b-row>
      <h6 class="mt-4 mb-2">
        Horários de maior atividade
      </h6>
      <vue-apex-charts
        type="heatmap"
        height="400"
        :options="chartOptions"
        :series="series"
      />
    </b-card>

    <!-- REGRAS + INFORMAÇÕES ADICIONAIS -->
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          class="shadow rounded-pill-xl p-4 h-100"
          style="background-color: #f8f9fa"
        >
          <div class="d-flex align-items-center mb-3">
            <b-icon
              icon="clipboard-check"
              variant="primary"
              font-scale="1.8"
              class="mr-2"
            />
            <div>
              <h5 class="mb-1">
                Regras do Atendimento
              </h5>
              <p class="text-muted small mb-0">
                Configure as políticas que o assistente seguirá.
              </p>
            </div>
          </div>
          <div class="text-right">
            <b-button
              variant="outline-primary"
              size="sm"
              class="rounded-pill px-3"
              @click="modalRegras = true"
            >
              ✏️ Editar Regras
            </b-button>
          </div>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="8"
      >
        <b-card class="shadow rounded-pill-xl p-0 d-flex flex-column h-100">
          <!-- Cabeçalho e botão "Nova Informação" -->
          <div class="p-4">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
              <h5 class="mb-2 mb-md-0">
                Base de Conhecimento
              </h5>
              <b-button
                v-b-tooltip.hover.bottom="informacoes.length >= 20 ? 'Limite máximo de 20 informações atingido' : 'Adicionar nova informação'"
                variant="outline-primary"
                size="sm"
                class="rounded-pill px-3"
                :disabled="informacoes.length >= 20"
                @click="modalAdicionar = true"
              >
                + Nova Informação
              </b-button>
            </div>
          </div>

          <!-- Conteúdo rolável -->
          <div
            style="overflow-y: auto; max-height: 400px;"
            class="px-4"
          >
            <template v-if="informacoes.length > 0">
              <b-row>
                <b-col
                  v-for="(info, i) in informacoes"
                  :key="i"
                  cols="12"
                  class="animate__animated animate__fadeIn"
                >
                  <div
                    class="rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start"
                    :style="{ backgroundColor: info.cor || '#f5f5f5', borderRadius: '1rem', padding: '1.25rem', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }"
                  >
                    <div
                      class="flex-grow-1 mr-md-3"
                      style="word-break: break-word; overflow-wrap: break-word; min-width: 0;"
                    >
                      <h6 class="mb-1">
                        {{ info.titulo }}
                      </h6>
                      <p class="text-muted mb-3 mb-md-0">
                        {{ info.conteudo }}
                      </p>
                    </div>
                    <div class="d-flex flex-column align-items-start align-items-md-end">
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="mb-2 mb-md-1 rounded-pill px-3"
                        @click="editarInfo(i)"
                      >
                        <b-icon icon="pencil" />
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        class="rounded-pill px-3"
                        @click="removerInfo(i)"
                      >
                        <b-icon icon="trash" />
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <div class="text-center text-muted mb-3">
                Você ainda não adicionou nenhuma informação.
              </div>
            </template>
          </div>

          <!-- Rodapé fixo com o botão "Ensinar" -->
          <div
            class="position-absolute"
            style="bottom: 1rem; right: 1rem; z-index: 10;"
          >
            <div class="position-relative d-inline-block">
              <b-button
                :variant="botaoMagico ? 'warning' : 'success'"
                size="sm"
                class="rounded-pill px-3 py-1 position-relative overflow-hidden"
                style="z-index: 2; font-size: 0.85rem;"
                @click="ensinarBot"
              >
                <span
                  v-if="botaoMagico"
                  class="text-white fw-bold"
                >✨ Ensinando... ✨</span>
                <span v-else>Ensinar</span>

                <!-- Estrelas mágicas (topo e base) -->
                <div
                  v-if="botaoMagico"
                  class="magic-stars position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-between align-items-center"
                  style="pointer-events: none; z-index: 3;"
                >
                  <div class="d-flex gap-1 mt-1">
                    <span class="star">✨</span>
                    <span class="star">🌟</span>
                    <span class="star">✨</span>
                    <span class="star">💫</span>
                    <span class="star">✨</span>
                  </div>
                </div>

                <!-- Poeira mágica -->
                <div
                  v-if="botaoMagico"
                  class="magic-dust position-absolute top-0 start-0 w-100 h-100"
                  style="z-index: 4;"
                >
                  <span
                    v-for="n in 20"
                    :key="'dust' + n"
                    class="dust"
                  />
                </div>
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal de Edição de Regras -->
    <!-- Modal de Edição de Regras -->
    <b-modal
      v-model="modalRegras"
      title="Editar Regras do Atendimento"
      hide-footer
    >
      <b-tabs card>
        <b-tab
          v-for="categoria in categorias"
          :key="categoria.id"
          :title="categoria.name"
        >
          <b-form-group
            :label="categoria.description"
          >
            <b-form-textarea
              v-model="formRegras[categoria.id]"
              :maxlength="250"
              rows="3"
              placeholder="Escreva a resposta para esta regra..."
            />
            <b-form-text class="text-muted float-right mt-1">
              {{ formRegras[categoria.id] ? formRegras[categoria.id].length : 0 }}/250 caracteres
            </b-form-text>
          </b-form-group>

        </b-tab>

      </b-tabs>
      <div class="text-right mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="modalRegras = false"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          @click="salvar"
        >
          Salvar Regras
        </b-button>
      </div>
    </b-modal>

    <!-- Modal de Integração com META -->
    <b-modal
      v-model="modalMeta"
      title="Integração com META"
      hide-footer
    >
      <b-form @submit.prevent="salvarMeta">
        <b-form-group label="Número de Telefone (ID)">
          <b-form-input
            v-model="form.metaPhone"
            placeholder="Ex: 554899999999"
            required
          />
        </b-form-group>
        <b-form-group label="Token Permanente">
          <b-form-input
            v-model="form.metaToken"
            placeholder="Cole aqui o token da sua API WhatsApp"
            required
          />
        </b-form-group>
        <div class="text-right">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="modalMeta = false"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            type="submit"
          >
            Salvar
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Modal de Nova Informação -->
    <b-modal
      v-model="modalAdicionar"
      title="Nova Informação"
      hide-footer
    >
      <b-form @submit.prevent="confirmarAdicao">
        <b-form-group label="Palavra chave">
          <b-form-input
            v-model="novaInfo.titulo"
            required
          />
        </b-form-group>
        <b-form-group label="Texto (máx. 250 caracteres)">
          <b-form-textarea
            v-model="novaInfo.conteudo"
            :maxlength="250"
            rows="3"
            required
          />
        </b-form-group>
        <div class="text-right">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="modalAdicionar = false"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            type="submit"
          >
            Adicionar
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Modal de Edição de Informação -->
    <b-modal
      v-model="modalEditar"
      title="Editar Informação"
      hide-footer
    >
      <b-form @submit.prevent="confirmarEdicao">
        <b-form-group label="Título">
          <b-form-input
            v-model="novaInfo.titulo"
            required
          />
        </b-form-group>
        <b-form-group label="Texto (máx. 250 caracteres)">
          <b-form-textarea
            v-model="novaInfo.conteudo"
            :maxlength="250"
            rows="3"
            required
          />
        </b-form-group>
        <div class="text-right">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="modalEditar = false"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            type="submit"
          >
            Salvar
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      v-model="mostrarChat"
      size="lg"
      centered
      title="Teste com o ManyConvert Bot"
    >
      <div
        ref="chatContainer"
        class="p-3 rounded position-relative"
        style="
          max-height: 400px;
          overflow-y: auto;
          background: linear-gradient(to bottom, #f0f4ff, #ffffff);
          background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');
          background-blend-mode: overlay;
        "
      >
        <div
          v-for="(msg, index) in mensagens"
          :key="index"
          :class="['d-flex', msg.remetente === 'Você' ? 'justify-content-end' : 'justify-content-start', 'mb-3']"
        >
          <!-- Avatar do Bot -->
          <img
            v-if="msg.remetente !== 'Você'"
            src="https://cdn-icons-png.flaticon.com/512/4712/4712038.png"
            alt="Bot"
            class="rounded-circle mr-2"
            style="width: 36px; height: 36px;"
          >

          <!-- Balão de mensagem -->
          <div
            :class="[
              'p-2',
              msg.remetente === 'Você' ? 'bg-success text-white' : 'bg-white text-dark',
            ]"
            style="max-width: 70%; word-wrap: break-word; border-radius: 18px;"
          >
            {{ msg.texto }}
          </div>
        </div>

        <!-- Animação de digitando -->
        <div
          v-if="digitando"
          class="d-flex justify-content-start align-items-center ml-1"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/4712/4712038.png"
            alt="Bot"
            class="rounded-circle mr-2"
            style="width: 36px; height: 36px;"
          >
          <div
            class="bg-white px-3 py-2 rounded-pill text-muted"
            style="max-width: 70%;"
          >
            Digitando<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
          </div>
        </div>
      </div>

      <!-- Campo de entrada -->
      <div class="mt-3 d-flex">
        <b-form-input
          v-model="mensagem"
          placeholder="Digite sua mensagem..."
          @keyup.enter="enviarMensagem"
        />
        <b-button
          variant="primary"
          class="ml-2"
          @click="enviarMensagem"
        >
          Enviar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormTextarea,
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import {
  buscaBot, editInfosMetaAccount, editRoleBot, saveKnowledge, getMessage, editBot, buscaCategorias,
} from '../../../functions/basics/bot'
import { buscaMetricas } from '../../../functions/basics/chat'
import stores from '../../../functions/basics/stores'
import EmbeddedSignup from './EmbeddedSignup'
import SelecionarPersonalidade from './SelecionarPersonalidade.vue'

export default {
  name: 'BotEditar',
  components: {
    EmbeddedSignup,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormTextarea,
    VueApexCharts,
    SelecionarPersonalidade,
  },
  data() {
    const cores = ['#e3f2fd', '#f3e5f5', '#ffe0b2', '#e8f5e9', '#fff3e0', '#e0f2f1']
    return {
      carregando: true,
      mostrarAvancado: false,
      mostrarModalPersonalidade: false,
      series: [], // será preenchido com formatToHeatmapSeries(apiData)
      chartOptions: {
        chart: {
          toolbar: { show: false },
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            colorScale: {
              ranges: [
                {
                  from: 0, to: 1, name: 'Baixo', color: '#DCE775',
                },
                {
                  from: 2, to: 5, name: 'Médio', color: '#FFD54F',
                },
                {
                  from: 6, to: 15, name: 'Alto', color: '#FF7043',
                },
              ],
            },
          },
        },
        xaxis: {
          categories: Array.from({ length: 24 }, (_, i) => `${i}h`),
        },
        dataLabels: { enabled: false },
      },
      categorias: [],
      formRegras: {},
      mostrarChat: false,
      mensagem: '',
      mensagens: [{ remetente: 'Bot', texto: 'Oi! Legal o seu interesse pela IA da ManyConvert! 😊\n Esse chat teste recebe somente texto mas, no WhatsApp, o assistente entende áudio! 🎧' }, { remetente: 'Bot', texto: 'Respondo sobre cancelamento, rastreio, trocas e entregas, e você pode adicionar mais informações à minha base! 🚀 Vamos conversar mais! 😄' }],
      digitando: false,
      estaEnsinando: false,
      botaoMagico: false,
      modalMeta: false,
      metricas: [
        {
          label: 'Atendimentos', valor: '-', icone: 'headset', cor: '#e3f2fd',
        },
        {
          label: 'Contatos únicos', valor: '-', icone: 'people-fill', cor: '#e8f5e9',
        },
        {
          label: 'Envios', valor: '-', icone: 'chat-square-text', cor: '#fff3e0',
        },
        {
          label: 'CSAT', valor: '-.- ⭐', icone: 'star-fill', cor: '#f3e5f5',
        },
      ],
      graficoHorarios: {
        labels: ['08h', '10h', '12h', '14h', '16h', '18h'],
        datasets: [
          {
            label: 'Mensagens',
            data: [12, 19, 8, 14, 20, 11],
            backgroundColor: '#42a5f5',
            fill: true,
            tension: 0.4,
          },
        ],
      },
      modalRegras: false,
      modalAdicionar: false,
      form: {
        metaPhone: '',
        metaToken: '',
        regraEntrega: '',
        regraTroca: '',
        regraCancelamento: '',
        nome: 'Leo',
        tipo: 'Suporte',
        lojaId: 1,
        avatar: null,
        personalidade: 'Neutro',
        mensagemTransferencia: '',
        csatAtivo: false,
        csatTempo: 30,
      },
      tiposBot: ['Suporte', 'Vendas', 'Pós-venda'],
      opcoesLoja: [
        { value: null, text: 'Selecione uma loja' },
        { value: 1, text: 'Loja A' },
        { value: 2, text: 'Loja B' },
      ],
      informacoes: [],
      modalEditar: false,
      indiceEdicao: null,
      novaInfo: { titulo: '', conteudo: '' },
      cores,
    }
  },
  computed: {
    nomePersonalidade() {
      const mapa = {
        1: 'Neutro',
        2: 'Empático',
        3: 'Divertido',
        4: 'Jovem',
      }
      return mapa[this.form.personalidade] || 'Não definido'
    },
  },
  async created() {
    try {
      await this.carregarCategorias()
      await this.selecionaBot()
      await this.carregarLojas()
      await this.carregarMetricas()
    } catch (error) {
      console.error('Erro ao carregar dados:', error)
      this.$bvToast.toast('Erro ao carregar informações do assistente', {
        title: 'Erro',
        variant: 'danger',
        solid: true,
      })
    } finally {
      this.carregando = false
    }
  },
  methods: {
    async transformarRelatorio(relatorio, distribuicao) {
      const totalMensagensBot = distribuicao.reduce((soma, item) => soma + item.total, 0)

      return [
        {
          label: 'Atendimentos',
          valor: relatorio.totalAtendimentos ?? '-',
          icone: 'headset',
          cor: '#e3f2fd',
        },
        {
          label: 'Contatos únicos',
          valor: relatorio.clientesUnicos ?? '-',
          icone: 'people-fill',
          cor: '#e8f5e9',
        },
        {
          label: 'Envios',
          valor: totalMensagensBot,
          icone: 'chat-square-text',
          cor: '#fff3e0',
        },
        {
          label: 'CSAT',
          valor: `${relatorio.mediaCsat?.toFixed(1) || '-.-'} ⭐`,
          icone: 'star-fill',
          cor: '#f3e5f5',
        },
      ]
    },
    async formatToHeatmapSeries(data) {
      const diasMap = {}

      data.forEach(item => {
        if (!diasMap[item.dia]) {
          // Inicializa array de 24h com 0
          diasMap[item.dia] = Array(24).fill(0)
        }
        diasMap[item.dia][item.hora] = item.total
      })

      // Converte para o formato esperado
      return Object.keys(diasMap).map(dia => ({
        name: dia,
        data: diasMap[dia],
      }))
    },
    async carregarMetricas() {
      const metricas = await buscaMetricas(this.$route.params.botId, 6, 2025)
      this.metricas = await this.transformarRelatorio(metricas.relatorio, metricas.distribuicao)
      this.series = await this.formatToHeatmapSeries(metricas.distribuicao)
      console.log('series: ', this.series)
    },
    async carregarCategorias() {
      const categorias = await buscaCategorias()
      this.categorias = categorias
    },
    async carregarLojas() {
      const lojas = await stores()

      this.opcoesLoja = [
        { value: null, text: 'Selecione uma loja' },
        ...lojas.map(loja => ({
          value: loja.id,
          text: loja.name,
        })),
      ]
      console.log(lojas)
    },
    abrirChat() {
      this.mostrarChat = true
    },
    enviarMensagem() {
      if (!this.mensagem.trim()) return

      // Mensagem do usuário
      this.mensagens.push({ remetente: 'Você', texto: this.mensagem })

      // Scroll automático para o final
      this.$nextTick(() => {
        this.scrollToBottom()
      })

      const textoUsuario = this.mensagem
      this.mensagem = ''

      // Mostrar "digitando..."
      this.digitando = true

      const userData = JSON.parse(localStorage.getItem('userData'))

      getMessage(textoUsuario, this.$route.params.botId, userData.id)
        .then(response => {
          this.digitando = false
          this.mensagens.push({ remetente: 'Bot', texto: response.resposta })
        })

      this.$nextTick(() => {
        this.scrollToBottom()
      })

      // setTimeout(() => {
      //   // Remover "digitando"
      //   this.digitando = false;

      //   // Mensagem do bot
      //   this.mensagens.push({ remetente: 'Bot', texto: textoUsuario });

      //   this.$nextTick(() => {
      //     this.scrollToBottom();
      //   });
      // }, 1200);
    },
    scrollToBottom() {
      const el = this.$refs.chatContainer
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    },
    async ensinarBot() {
      this.estaEnsinando = true
      this.botaoMagico = true
      console.log(this.informacoes)
      await saveKnowledge(this.informacoes, this.$route.params.botId)
        .then(() => {
          this.$bvToast.toast('Recebido! Já tô aprendendo e vou usar no momento certo. Obrigado pela paciência! 🚀', {
            title: 'Conhecimento Salvo!',
            variant: 'success',
            solid: true,
          })
        })
        .catch(err => {
          console.error('Erro ao salvar conhecimento:', err)
          // Aqui você pode exibir um toast de erro também, se quiser
          this.$bvToast.toast('Opa! Algo deu errado ao salvar o conhecimento. 😕', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          })
        })
      // Depois de 3 segundos, volta ao estado normal
      setTimeout(() => {
        this.estaEnsinando = false
        this.botaoMagico = false
      }, 3000)
    },
    async selecionaBot() {
      const data = await buscaBot(this.$route.params.botId)
      console.log(data)
      Object.assign(this.form, {
        metaPhone: data.bot.whatsapp_phone_number_id,
        metaToken: data.bot.access_token,
        nome: data.bot.nome,
        tipo: data.bot.tipo,
        avatar: data.bot.avatar,
        lojaId: data.bot.store_id,
        personalidade: data.bot.persona,
        mensagemTransferencia: data.bot.mensagem_transferencia,
        csatAtivo: data.bot.csat,
        csatTempo: data.bot.delay_csat,
      })

      // Preencher regras por role
      this.formRegras = {}
      console.log('1: ', this.formRegras)
      this.categorias.forEach(cat => {
        const regraSalva = data.regras.find(r => r.role === cat.id)
        this.formRegras[cat.id] = regraSalva ? regraSalva.description : ''
      })
      console.log('2: ', this.formRegras)
      // Preencher informacoes por knowledge
      this.informacoes = data.knowledge

      this.informacoes = [
        ...data.knowledge.map(dado => ({
          titulo: dado.keyword,
          conteudo: dado.knowledge,
        })),
      ]
    },
    salvarMeta() {
      this.modalMeta = false
      const data = this.form

      editInfosMetaAccount(this.$route.params.botId, data)
        .then(resp => this.$bvToast.toast('Credenciais da Meta salvas com sucesso!', {
          title: 'Meta API',
          variant: 'success',
          solid: true,
        }))
    },
    trocarAvatar() {
      this.$refs.avatarInput.click()
    },
    confirmarAdicao() {
      if (this.informacoes.length >= 20) {
        this.$bvToast.toast('Você atingiu o limite máximo de 20 informações.', {
          title: 'Limite atingido',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4000,
        })
        return
      }
      const cor = this.cores[Math.floor(Math.random() * this.cores.length)]
      this.informacoes.push({ ...this.novaInfo, cor })
      this.novaInfo = { titulo: '', conteudo: '' }
      this.modalAdicionar = false
    },
    confirmarEdicao() {
      if (this.indiceEdicao !== null) {
        const cor = this.informacoes[this.indiceEdicao].cor || this.cores[Math.floor(Math.random() * this.cores.length)]
        this.$set(this.informacoes, this.indiceEdicao, { ...this.novaInfo, cor })
        this.modalEditar = false
        this.novaInfo = { titulo: '', conteudo: '' }
        this.indiceEdicao = null
      }
    },
    adicionarInfo() {
      const cor = this.cores[Math.floor(Math.random() * this.cores.length)]
      this.informacoes.push({ ...this.novaInfo, cor })
      this.novaInfo = { titulo: '', conteudo: '' }
    },
    editarInfo(index) {
      this.indiceEdicao = index
      this.novaInfo = { ...this.informacoes[index] }
      this.modalEditar = true
    },
    removerInfo(index) {
      this.informacoes.splice(index, 1)
    },
    onAvatarChange(event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.form.avatar = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },

    salvar() {
      const data = Object.entries(this.formRegras).map(([role, description]) => ({
        role: Number(role),
        description,
      }))

      editRoleBot(this.$route.params.botId, data)
        .then(() => {
          this.$bvToast.toast('Bot/IA atualizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          })
          this.modalRegras = false
        })
    },
    salvarInfoBot() {
      if (this.form.csatAtivo && (this.form.csatTempo < 30 || this.form.csatTempo > 660)) {
        this.$bvToast.toast('Por favor, defina um tempo válido para o CSAT (entre 30 e 660 minutos).', {
          title: 'Validação de CSAT',
          variant: 'warning',
          solid: true,
        })
        return
      }
      editBot(this.$route.params.botId, this.form)
        .then(resp => this.$bvToast.toast('Bot/IA atualizado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        }))
    },
  },
}
</script>

  <style scoped>
  .avatar-wrapper {
    display: inline-block;
    position: relative;
  }

  .avatar-wrapper:hover .avatar-button {
    opacity: 1;
    transform: translateY(0);
  }

  .avatar-button {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);
    opacity: 0;
    transition: all 0.3s ease;
    font-size: 0.75rem;
    padding: 0.25rem 0.75rem;
  }
  .bot-editar {
    max-width: 900px;
    margin: auto;
  }
  .bot-avatar-lg {
    width: 140px;
    height: 140px;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .bot-avatar-lg {
    width: 140px;
    height: 140px;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .rounded-pill-xl {
    border-radius: 1.5rem;
  }

  .magic-stars {
  position: absolute;
  top: -10px; /* Subiu as estrelas */
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
  pointer-events: none;
}

  .magic-stars .star {
    animation: sparkle 1.2s infinite alternate;
  font-size: 1rem;
  opacity: 0.8;
  filter: drop-shadow(0 0 2px gold);
}

@keyframes sparkle {
  0% { transform: translateY(0) scale(1); opacity: 0.6; }
  100% { transform: translateY(-4px) scale(1.3); opacity: 1; }
}

.dust {
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 1;
}

.dust .particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: radial-gradient(circle, rgba(255, 215, 0, 0.8), transparent);
  border-radius: 50%;
  animation: floatDust 1.5s ease-out infinite;
  opacity: 0.6;
}

.dust .particle:nth-child(1) {
  top: 50%;
  left: 10%;
  animation-delay: 0s;
}
.dust .particle:nth-child(2) {
  top: 20%;
  left: 80%;
  animation-delay: 0.2s;
}
.dust .particle:nth-child(3) {
  top: 70%;
  left: 30%;
  animation-delay: 0.4s;
}
.dust .particle:nth-child(4) {
  top: 40%;
  left: 60%;
  animation-delay: 0.6s;
}
.dust .particle:nth-child(5) {
  top: 60%;
  left: 50%;
  animation-delay: 0.8s;
}

@keyframes floatDust {
  0% {
    transform: translateY(0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-10px) scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-20px) scale(0.8);
    opacity: 0;
  }
}

/* Poeira mágica */
.magic-dust {
  pointer-events: none;
}

.magic-dust .dust {
  position: absolute;
  width: 4px;
  height: 4px;
  background: gold;
  border-radius: 50%;
  opacity: 0.8;
  animation: float 2s infinite ease-in-out;
}

.magic-dust .dust:nth-child(odd) {
  background: #ffeb3b;
}

.magic-dust .dust:nth-child(even) {
  background: #fff8dc;
}

@keyframes float {
  0% {
    transform: translate(0, 0) scale(0.7);
    opacity: 0.8;
  }
  50% {
    transform: translate(10px, -15px) scale(1.1);
    opacity: 0.5;
  }
  100% {
    transform: translate(-5px, -30px) scale(0.9);
    opacity: 0;
  }
}

/* Loading dentro do Card */
.card-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 1.5rem;
}

.loading-content {
  text-align: center;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

  </style>